import { FC } from 'react';
import { Gallery, GalleryProps } from '@zoopla/gallery';
import { PageGalleryContent } from './ListingCard.styles';
import { useInView } from 'react-intersection-observer';

type GalleryLazyLoaderProps = GalleryProps & { lazyLoad: boolean };

const GalleryLazyLoader: FC<React.PropsWithChildren<GalleryLazyLoaderProps>> = (
    props
) => {
    const lazyLoad = props.lazyLoad;

    const { ref, inView } = useInView({
        triggerOnce: true,
        rootMargin: '1400px'
    });

    const shouldLoadGallery = !lazyLoad || inView;

    return (
        <PageGalleryContent ref={ref}>
            {shouldLoadGallery && <Gallery {...props} />}
        </PageGalleryContent>
    );
};

export default GalleryLazyLoader;
